/**
 * @packageDocumentation
 */

import { Component, Vue } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import mutation from '../../mutations/addSuggestionsList';
import query from '../../queries/projectAndSuggestionsListForBookshop';
import ProjectCard from '../shared/projectCard.vue';
import SectionTitle from '../shared/sectionTitle.vue';
import SingleInputDialog from '../shared/singleInputDialog.vue';
import SingleMainContainer from '../shared/singleMainContainer.vue';
import CreateOrVisitSuggestionsList from './createOrVisitSuggestionsList.vue';
import { ViewerContext } from '../../types/viewer_context';

@Component({
  components: {
    ProjectCard,
    SingleInputDialog,
    SingleMainContainer,
    SectionTitle,
    CreateOrVisitSuggestionsList,
  },
})
export default class Project extends Vue {
  @Getter public viewerContext!: ViewerContext;

  public projectQuery = query;

  public get projectQueryVariables() {
    return {
      projectId: this.$route.params.projectId,
      bookshopId: this.viewerContext.institutionId,
    };
  }

  public async handleOk(value: string, project: any) {
    const queryResponse = await this.$apollo.mutate({
      mutation,
      variables: {
        name: value,
        projectId: project.id,
        libraryId: project.library.id,
        bookshopId: this.viewerContext.institutionId,
        bookshopMessage: null,
      },
      refetchQueries: [
        { query: this.projectQuery, variables: this.projectQueryVariables },
      ],
    });
    if (queryResponse.data) {
      const suggestionsListId = queryResponse.data.addSuggestionsList.id;
      this.$router.push({
        name: 'suggestionsList',
        params: { suggestionsListId },
      });
    }
  }

  public openDialog() {
    const dialog = this.getDialog();
    dialog.show();
  }

  private getDialog(): any {
    return this.$refs.inputDialog;
  }
}
